module.exports = __webpack_public_path__ + "assets/671cac6f1d714c181bb192bdc1ace1eb.mp3";